import React, { useContext } from 'react'
import { Box, Flex, Text, Tooltip } from '@mantine/core'
import SingleCustomerContext from '../../Customer-Context/SingleCustomerContext'
import { evaluateDisplayIf } from '../../../ideaNiv/right-bar/evidence-card/CardInfoTextItem'
import { MAIN_DARK_PRIMARY } from '../../../../constants/colors'
import { getNestedValue } from '../../../ideaNiv/Funcs'

const CustomerAttributes = () => {

  const { customer, ideaInfoTabsConfig } = useContext(SingleCustomerContext)
  const tabsConfig = ideaInfoTabsConfig || {};
  const tabKeys = Object.keys(tabsConfig);

  const item = {company: {}} as Record<string, any>;
  item.company = customer

  // Filter tabs based on displayIf condition
  const filteredTabs = tabKeys.filter((tabKey) => {
    const tab = tabsConfig[tabKey];
    return evaluateDisplayIf(item, tab.displayIf);
  });

  return (
    <Flex mt={12}>
      <Box
        ml={2}
        h={32}
        pr={8.45}
        pl={2}
        sx={{
          borderLeft: `1px solid ${MAIN_DARK_PRIMARY}`,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center'
        }}>
      </Box>
      <Box>
        <Flex gap={8}>
          {filteredTabs.map((tabKey) => {
            const tab = tabsConfig[tabKey];
            return (
              <React.Fragment key={tabKey}>
                <Box>
                  <Box
                    ml={2}
                    h={32}
                    pr={8.45}
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center'
                    }}>
                    <Text fz={12} fw={500} color={MAIN_DARK_PRIMARY}>{tab.label.toUpperCase()}</Text>
                    
                  </Box>
                </Box>
                {tab?.properties?.map((attribute: any, index: number) => {
                  const path = attribute?.fieldPath;
                  const relevantValue = getNestedValue(item, path);
                  const label = attribute?.label;

                  return (relevantValue && label &&
                    <Box
                      key={`${tabKey}-${index}`}
                      h={32}
                      pr={8.45}
                      pl={7.6}
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        borderLeft: '1px solid #d8d8d8',
                        height: '100%',
                        overflow: 'hidden'
                      }}
                    >
                      <Text fz={12} color="dimmed" truncate>{label}</Text>
                      <Tooltip label={relevantValue}>
                        <Text fz={14} 
                          fw={500} 
                          color={MAIN_DARK_PRIMARY} 
                          maw={100}
                          truncate
                        >{relevantValue}</Text>
                      </Tooltip>
                      
                    </Box>
                  );
                })}
              </React.Fragment>
            );
          })}
        </Flex>
      </Box> 
    </Flex>
    
  )
}

export default CustomerAttributes